export const fetchFilterData = (path: string, fileName: string, appFilters) =>
  new Promise((resolve, reject) => {
    fetch(`${process.env.PUBLIC_URL}/data/filters/${path}/${fileName}.json`)
      .then(response => response.json())
      .then(data => {
        appFilters[path] = data;
        resolve();
      })
      .catch(error => {
        console.error(`Error: Failed to load "data/filters/${path}/${fileName}.json".`);
        fetch(`${process.env.PUBLIC_URL}/data/filters/${path}/default.json`)
          .then(response => response.json())
          .then(data => {
            appFilters[path] = data;
            console.log(`Default ${path} filters loaded instead`);
            resolve();
          })
          .catch(error => {
            console.error(`Error: Failed to load default ${path} filters.`);
            reject();
          });
      });
  });
